import React, { useState, useCallback } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { RootState } from "../../../reducers";
import { syncEditorToolbarFromSelection } from "../../../lib/editorToolbarSync";
import {
  RestoreSelection,
  snapshotEditorSelectionIfInScreen,
} from "../../../lib/lib";
const arr = [13, 15, 17, 19, 21, 23, 25];
function Ftsize() {
  const dispatch = useDispatch();
  const store = useStore<RootState>();
  const nowFt = useSelector<RootState, number>((state) => state.editor.size);
  const [isOpen, setIsOpen] = useState(false);
  const __syncToolbar = useCallback(() => {
    syncEditorToolbarFromSelection(
      dispatch,
      document.getElementById("screen"),
      store.getState().editor
    );
  }, [dispatch, store]);
  const __changeFt = useCallback(
    (index: string) => {
      RestoreSelection();
      document.execCommand("fontSize", false, index);
      setIsOpen(false);
      __syncToolbar();
    },
    [__syncToolbar]
  );
  const __changeOpen = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);
  return (
    <div className="ftsize">
      <button
        className="now-ft"
        onMouseDown={(e) => {
          snapshotEditorSelectionIfInScreen();
          e.preventDefault();
        }}
        onClick={__changeOpen}
      >
        {nowFt}pt
        <img src="/assets/editor/down.svg" alt="열기" />
      </button>
      {isOpen ? (
        <div className="ft-list">
          {arr.map((item, idx) => {
            return (
              <button
                key={idx}
                className="ft-card"
                onMouseDown={(e) => {
                  snapshotEditorSelectionIfInScreen();
                  e.preventDefault();
                }}
                style={
                  item === nowFt
                    ? { fontWeight: "bold", color: "#3597ec" }
                    : undefined
                }
                onClick={() => {
                  __changeFt(String(idx + 1));
                }}
              >
                {item}pt
                {nowFt === item ? <div className="sky-circle" /> : undefined}
              </button>
            );
          })}
        </div>
      ) : undefined}
    </div>
  );
}

export default Ftsize;
